<template>
    <main-content>
        <div class="bg-white shadow-sm rounded p-4">
            <div>
                <div>
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <a
                                @click="setTab('single-request')"
                                class="nav-link active"
                                data-toggle="tab"
                                href="#single-request"
                                role="tab"
                                aria-selected="false"
                            >
                                {{ $t("label.settlement_request") }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a 
                                @click="setTab('gregarious-request')"
                                class="nav-link"
                                data-toggle="tab"
                                href="#gregarious-request"
                                role="tab"
                                aria-selected="false"
                            >
                                {{ $t("label.settlement_request_with_excel") }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="tab-content mt-4">
                <div class="tab-pane active" id="single-request" v-if="active_tab == 'single-request'">
                    <settlement-form :form_data="form_data"
                                    :form_meta_data="form_meta_data"
                                    :on_submit="sendCode"
                                    @settlement="settlement"
                                    :password="password"
                    >
                    </settlement-form>
                </div>
                <div class="tab-pane" id="gregarious-request" v-if="active_tab == 'gregarious-request'">
                    <settlement-excel-form ref="SettlementExcelForm" 
                                            @settlement_excel="handleSendExcelRequest" 
                                            :form_meta_data="form_meta_data">
                    </settlement-excel-form>
                </div>
            </div>
        </div>
    </main-content>
</template>

<script>
    import SettlementForm from './components/settlement-form'
    import SettlementExcelForm from './components/settlement-excel-form'
    import mainContent from '@/components/main-content'
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";
    import {walletService} from "@/common/api.service";
    import {
        walletSettlementTransferType,
        walletSettlementTransferTypeStr
    } from "@/constants/walletSettlementTransferType";
    import Inputmask from "inputmask";

    export default {
        components: {
            SettlementForm,
            mainContent,
            SettlementExcelForm
        },
        data() {
            return {
                active_tab: 'single-request',
                walletSettlementTransferTypeStr,
                walletSettlementTransferType,
                amount: 0,
                password: {
                    value: '',
                },
                form_data: [
                    {
                        amount: '',
                        destination_number: '',
                        destination_name: '',
                        transfer_description: '',
                        track_id: '',
                        transfer_type: walletSettlementTransferType.Direct,
                    },
                ],
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('wallets.btn.create_settlement_request'),
                },
            };
        },
        methods: {
            setTab(tab) {
                this.active_tab = tab
            },
            masked() {
                setTimeout(() => {
                    document.getElementById("google_authenticator_code") &&
                    Inputmask("9     9     9     9     9     9").mask(document.getElementById("google_authenticator_code"));
                }, 100);
            },
            sendCode() {

                if (!this.form_data.should_two_factor_settlement) {
                    this.settlement()
                    return;
                }

                let form = $('#submit_form');

                form.validate({
                    rules: {
                        password: {
                            required: true,
                        },
                    },
                });

                if (!form.valid()) {
                    window.scrollTo({top: 1, behavior: 'smooth'});
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;
                this.form_data.otp = '';

                let params = {
                    wallet_id: this.$route.params.hashid,
                    password: this.password.value,
                    two_factor_type: this.form_data.two_factor_type,
                };

                walletService.sendVerificationCode(params).then(response => {

                    this.form_data.two_factor_type = response.data.data.two_factor_type;
                    this.masked();

                    $('#approve_modal').modal('show');
                    this.$forceUpdate();

                    this.toastr.success(response.data.message);

                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);

                    if (response.data && response.data.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    window.scrollTo({top: 1, behavior: 'smooth'});
                }).finally(() => {
                    this.form_meta_data.submit_btn_progress = false;
                });
            },
            formatLess(price) {
                if (price == null || price === '' || price === 0) {
                    return 0;
                }

                return parseInt(price.replace(/,/g, ''));
            },
            settlement() {
                let form = $('#submit_form');

                form.validate({
                    rules: {
                        password: {
                            required: true,
                        },
                    },
                });

                if (!form.valid()) {
                    window.scrollTo({top: 1, behavior: 'smooth'});
                    return;
                }


                let params = {
                    wallet_hashid: this.$route.params.hashid,
                    otp: !this.form_data.otp ? '': this.toEng(this.form_data.otp),
                    two_factor_type: !this.form_data.two_factor_type ? '': this.form_data.two_factor_type,
                    transfers: this.form_data,
                    should_two_factor_settlement: this.form_data.should_two_factor_settlement,
                    password: this.password.value,
                };

                this.form_meta_data.submit_btn_progress = true;

                walletService.settlementAyande(params, this.$route.params.hashid).then(response => {
                    $('#approve_modal').modal('hide');
                    this.$router.push('/wallets');
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);

                    if (response.data && response.data.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    window.scrollTo({top: 1, behavior: 'smooth'});
                }).finally(() => {
                    this.form_meta_data.submit_btn_progress = false;
                });
            },

            handleSendExcelRequest() {
                this.$refs.SettlementExcelForm.settlement();
            }
        },
    }
</script>
